import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../common/components/ui/button';
import { CartDialogDeliveryCalendar } from './CartDialogDeliveryCalendar';
import { CartDialogConfirmCancel } from '../shared/CartDialogConfirmCancel';

export function CartDialogDeliveryDateExpired() {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (showConfirmation) {
    return <CartDialogConfirmCancel onBack={() => setShowConfirmation(false)} />;
  }

  return (
    <CartDialogDeliveryCalendar
      title={t('Das gewünschte Lieferdatum ist verfallen')}
      description={t('Bitte wählen Sie ein neues Lieferdatum.')}
    >
      <div className={'flex flex-col desktop:flex-row gap-2 justify-between'}>
        <div>{t('Sie können den Warenkorb verwerfen und einen neuen Warenkorb anlegen.')}</div>
        <Button
          variant={'primaryOutline'}
          onClick={() => setShowConfirmation(true)}
          data-testid={'cart-discard-button'}
        >
          {t('Gesamten Warenkorb verwerfen')}
        </Button>
      </div>
    </CartDialogDeliveryCalendar>
  );
}
